<template>
    <div v-if="isShow">
        <Header :isShowHeaderBot="isShowHeaderBot"></Header>
        <slot></slot>
        <Footer></Footer>
        <LittleDevil v-if="!isIntl"></LittleDevil>
        <BottomAds v-if="false"></BottomAds>
        <Activity></Activity>
        <AskPriceMessageNotify></AskPriceMessageNotify>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue';// 头部
    import Footer from '@/components/Footer.vue';// 尾部
    import LittleDevil from '@/components/LittleDevil.vue';// 小恶魔
    import BottomAds from '@/components/BottomAds.vue';// 底部广告
    import Activity from '@/components/Activity';
    import AskPriceMessageNotify from '@/components/AskPriceMessageNotify.vue';
    // 2021年518活动

    export default {
        name: 'SJMMall',
        components: {
            AskPriceMessageNotify,
            Header,
            Footer,
            LittleDevil,
            BottomAds,
            Activity
        },
        props: {
            // 是否显示
            isShow: {
                type: Boolean,
                default: true
            },
            // 是否显示头部下半部分
            isShowHeaderBot: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                isIntl: location.origin.includes('https://intl.3j-mall.com')
            };
        },
        created() {
            this.$marketingPropaganda();// 市场推广
        }
    };
</script>

<style scoped>

</style>
